import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axiosInstance";
import Close from "../../../../Assets/Icons/close-btn.svg";
import Logo from "../../../../Assets/Images/Logo-white.svg";
import AdminPanelIcon from "../../../../Assets/Icons/admin panel icon.svg";
import AboutIcon from "../../../../Assets/Icons/about icon.svg";
import CustomerSup from "../../../../Assets/Icons/message-question.svg";
import Logout from "../../../../Assets/Icons/logout-2.svg";
import { Link } from "react-router-dom";

function SideBar(props) {
  const [IsAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetchUserData();
  }, []);
  const fetchUserData = () => {
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        if (Res.data.user.authorities.includes("ROLE_ADMIN")) {
          setIsAdmin(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleLogout = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.assign("/");
  };

  return (
    <div className={props.MenuIsOpen ? "menu-list menu-is-open" : "menu-list"}>
      <section className="menu-head">
        <img
          alt="X"
          className="close"
          onClick={() => props.SetMenuIsOpen(false)}
          src={Close}
        />
        <img alt="Weddingly" className="logo" src={Logo} />
      </section>
      {IsAdmin ? (
        <>
          <Link className="menu-link" to="/Home/Terms">
            <div
              className="menu-item bottom-divider"
              onClick={() => props.SetMenuIsOpen(false)}
            >
              <img alt="" src={AboutIcon} />
              Terms and Data Privacy
            </div>
          </Link>
          <Link className="menu-link" to="/Home/AdminPanel">
            <div
              className="menu-item is-desktop bottom-divider"
              onClick={() => props.SetMenuIsOpen(false)}
            >
              <img alt="" src={AdminPanelIcon} />
              Admin Panel
            </div>
          </Link>
          <Link
            className="menu-link"
            target="_blank"
            to="https://weddingly.atlassian.net/servicedesk/customer/portals"
          >
            <div className="menu-item bottom-divider">
              <img alt="" src={CustomerSup} />
              Customer Support
            </div>
          </Link>
          <div className="menu-item" onClick={() => handleLogout()}>
            <img alt="" src={Logout} />
            Logout
          </div>
        </>
      ) : (
        <>
          <Link className="menu-link" to="/Home/Terms">
            <div
              className="menu-item bottom-divider"
              onClick={() => props.SetMenuIsOpen(false)}
            >
              <img alt="" src={AboutIcon} />
              Terms and Data Privacy
            </div>
          </Link>
          <Link
            className="menu-link"
            target="_blank"
            to="https://weddingly.atlassian.net/servicedesk/customer/portals"
          >
            <div className="menu-item bottom-divider">
              <img alt="" src={CustomerSup} />
              Customer Support
            </div>
          </Link>
          <div className="menu-item" onClick={() => handleLogout()}>
            <img alt="" src={Logout} />
            Logout
          </div>
        </>
      )}
    </div>
  );
}

export default SideBar;
